// extracted by mini-css-extract-plugin
export default {"cta":"gE-z","disabled":"hE-z"};